var form = $("form[data-id='panels-form']");
var product;
var sellingPlanID;

$(document).ready(function(e) {
  $(form)[0].reset();
  $(form).find("input[name='variant']").each(function() {
    if ($(this).is(":checked")) {
      product = $(this).val();
      sellingPlanID = $(this).data("selling-plan-id");

      $("input[name='id']").val(product);
      $("input[name='selling_plan']").val(sellingPlanID);
    }
  })
})

var subscriptionInput = $(form).find("input[name='subscribe']");

// values are for default 3 bottle

var subscriptionSavings = "";
var retailPrice = "";
var subscriptionPrice = "";
var frequencyDays = "";
var OTP = "";
var subscribed = true;

$(subscriptionInput).on("change", function () {
  if ($(this).val() === "subscribe") {
    subscribed = true;
  } else if ($(this).val() === "one-time") {
    subscribed = false;
  }
})

$(form).on("change", function () {
  console.log(subscribed);
  $(form).find("input[name='variant']").each(function() {
    if (subscribed === true) {
      $(this).val($(this).data("subscription-id"))
    } else {
      $(this).val($(this).data("otp-id"))
    }
    
    if ($(this).is(":checked")) {
      product = $(this).val();
      sellingPlanID = $(this).data("selling-plan-id");

      $("input[name='id']").val(product);
      $("input[name='selling_plan']").val(sellingPlanID);
    }
  })

  switch (product) {
    // 1 bottle:
    case "13669824757827":
      subscriptionSavings = "4.90";
      retailPrice = "49.00";
      subscriptionPrice = "44.10";
      frequencyDays = "30";
      OTP = "49.00";
      break;
    // 6 bottle:
    case "18283803082819":
      subscriptionSavings = "22.20";
      retailPrice = "282.00";
      subscriptionPrice = "199.80";
      frequencyDays = "180";
      OTP = "222.00";
      break;
    // 3 bottle:
    default: 
      subscriptionSavings = "11.10";
      retailPrice = "141.00";
      subscriptionPrice = "99.90";
      frequencyDays = "90";
      OTP = "111.00";
  }

  $(form).find("[data-id='subscription-savings']").text("(save $" + subscriptionSavings + ")");
  $(form).find(".subscripsave").text(subscriptionSavings);
  

  if (retailPrice === OTP) {
    $(form).find("[data-id='retail-price']").hide();
  } else {
    $(form).find("[data-id='retail-price']").text("$" + retailPrice);
    $(form).find("[data-id='retail-price']").show();
  }

  if (subscribed === true) {
    $(form).find("[data-id='package-price']").text("$" + subscriptionPrice);
    $(form).find("[data-id='frequency']").text("Every " + frequencyDays + " Days");
    $(form).find(".subscription-plan-info").show();
    $(form).find(".subscription-upsell").hide();
    $(form).find(".subscription-pct-savings").show();
    $(form).find(".variant1price").text("$44.10");
    $(form).find(".variant2price").text("$99.90");
    $(form).find(".variant3price").text("$199.80");
  } else if (subscribed === false) {
    $(form).find("[data-id='package-price']").text("$" + OTP);
    $(form).find("[data-id='frequency']").text("One Time Purchase");
    $(form).find(".subscription-plan-info").hide();
    $(form).find(".subscription-upsell").show();
    $(form).find(".subscription-pct-savings").hide();
    $(form).find(".variant1price").text("$49.00");
    $(form).find(".variant2price").text("$111.00");
    $(form).find(".variant3price").text("$222.00");
  }  
})

$(form).on("submit", function (e) {
  e.preventDefault();  
  $(form).find("button[type='submit']").prop("disabled", true);

  if (subscribed === true) {
    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: {
        quantity: $("input[name='quantity']").val(),
        id: $("input[name='id']").val(),
        "selling_plan": $("input[name='selling_plan']").val(),
      },
      dataType: 'json',
      complete: function(data) {
        window.location.href = '/cart'; 
      }
    });     
  
} else {
  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: {
      quantity: $("input[name='quantity']").val(),
      id: $("input[name='id']").val()
    },
    complete: function(data) {
      window.location.href = '/cart'; 
    }
  });     
}
});


